var _path, _rect, _rect2, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5C0 11.6929 11.1929 0.5 25 0.5C38.8071 0.5 50 11.6929 50 25.5C50 39.3071 38.8071 50.5 25 50.5C11.1929 50.5 0 39.3071 0 25.5Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(9 9.5)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13.5,
    width: 24,
    height: 24,
    rx: 3,
    fill: "#FFF7CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32.5L17.5613 27.8162C17.7771 27.1687 18.5639 26.9229 19.1099 27.3325L20.9323 28.6992C21.4659 29.0995 22.2344 28.8749 22.4686 28.2503L24.359 23.2093C24.6364 22.4697 25.6214 22.3285 26.0953 22.9604L27.2 24.4333C27.6 24.9667 28.4 24.9667 28.8 24.4333L34 17.5",
    stroke: "#FFC226",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 36.5,
    r: 3,
    fill: "#FFC226"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.95d96b4a3decb115bedd1110269e0353.svg";
export { ForwardRef as ReactComponent };